"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSolana = void 0;
const types_1 = require("../../../../../common/types");
const web3_js_1 = require("@solana/web3.js");
const AppMessages_1 = require("../types/AppMessages");
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const ServerMessage_1 = require("../types/ServerMessage");
const utils_1 = require("../utils");
class AppSolana {
    constructor(ws, timeout) {
        this.events = {};
        this.sessionId = '';
        this.send = (message) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const id = (0, utils_1.getRandomId)();
                const request = JSON.stringify(Object.assign(Object.assign({}, message), { id: id }));
                // Set up the timeout
                const timer = setTimeout(() => {
                    reject(new Error(`Connection timed out after ${this.timeout} ms`));
                }, this.timeout);
                this.events[id] = (response) => {
                    clearTimeout(timer);
                    if (response.type === ServerMessage_1.ServerMessageTypes.Error) {
                        reject(response.msg);
                    }
                    else {
                        resolve(response);
                    }
                };
                this.ws.send(request);
            });
        });
        this.signTransaction = (transaction) => __awaiter(this, void 0, void 0, function* () {
            const request = {
                type: AppMessages_1.AppMessageTypes.SignTransaction,
                network: types_1.NETWORK.SOLANA,
                transaction: transaction
                    .serialize({ requireAllSignatures: false, verifySignatures: false })
                    .toString('hex')
            };
            const response = (yield this.send(request));
            return web3_js_1.Transaction.from(Buffer.from(response.transaction, 'hex'));
        });
        this.signAllTransactions = (transactions) => __awaiter(this, void 0, void 0, function* () {
            const request = {
                type: AppMessages_1.AppMessageTypes.SignAllTransactions,
                network: types_1.NETWORK.SOLANA,
                transactions: transactions.map((transaction) => transaction
                    .serialize({ requireAllSignatures: false, verifySignatures: false })
                    .toString('hex'))
            };
            const response = (yield this.send(request));
            const parsed = response.transactions.map((tx) => web3_js_1.Transaction.from(Buffer.from(response.transactions[0], 'hex')));
            return parsed;
        });
        this.signMessage = (message) => __awaiter(this, void 0, void 0, function* () {
            const request = {
                type: AppMessages_1.AppMessageTypes.SignMessage,
                network: types_1.NETWORK.SOLANA,
                message
            };
            const response = (yield this.send(request));
            return Uint8Array.from(Buffer.from(response.signature, 'hex'));
        });
        this.ws = ws;
        this.timeout = timeout;
    }
}
exports.AppSolana = AppSolana;
_a = AppSolana;
AppSolana.build = ({ appMetadata, url, onUserConnect, timeout = 40 * 1000 // default timeout 40 sec
 }) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const ws = url ? new isomorphic_ws_1.default(url) : new isomorphic_ws_1.default('ws://localhost:3000/ws');
        const connection = new AppSolana(ws, timeout);
        connection.events[ServerMessage_1.ServerMessageTypes.UserConnected] = (data) => {
            const pk = new web3_js_1.PublicKey(Buffer.from(data.publicKey, 'hex'));
            onUserConnect({ publicKey: pk });
        };
        connection.ws.onopen = () => {
            connection.ws.onmessage = ({ data }) => {
                const response = JSON.parse(data);
                connection.events[response.id](response);
            };
            const request = (0, AppMessages_1.createInitAction)(Object.assign(Object.assign({}, appMetadata), { network: types_1.NETWORK.SOLANA }));
            // Set up the timeout
            const timer = setTimeout(() => {
                reject(new Error(`Connection timed out after ${connection.timeout} ms`));
            }, timeout);
            connection.events[request.id] = (response) => {
                clearTimeout(timer);
                if (response.type === ServerMessage_1.ServerMessageTypes.InitSuccess) {
                    connection.sessionId = response.sessionId;
                    resolve(connection);
                }
                else {
                    reject();
                }
            };
            connection.ws.send(JSON.stringify(request));
        };
    });
});
